/**
 * FreemiumCounter - Componente de teste SSR-safe
 *
 * Demonstra uso correto do Zustand com SSR:
 * - useEffect para hydration
 * - Estado local temporário até hydration
 * - Previne flash de conteúdo incorreto
 */

import { useEffect, useState } from 'react'
import { useFreemiumStore } from '../store/freemium-store'

export function FreemiumCounter() {
  const [isHydrated, setIsHydrated] = useState(false)

  const questionsUsed = useFreemiumStore((state) => state.questionsUsed)
  const questionsRemaining = useFreemiumStore((state) => state.questionsRemaining)
  const incrementQuestionsUsed = useFreemiumStore((state) => state.incrementQuestionsUsed)
  const urgencyLevel = useFreemiumStore((state) => state.getUrgencyLevel())
  const resetState = useFreemiumStore((state) => state.resetFreemiumState)

  // Hydrate store on client-side
  useEffect(() => {
    // Force rehydration
    useFreemiumStore.persist.rehydrate()
    setIsHydrated(true)
  }, [])

  // Prevent rendering until hydrated (prevents SSR mismatch)
  if (!isHydrated) {
    return (
      <div className="p-6 rounded-lg border border-gray-700 bg-gray-800">
        <p className="text-gray-400">Carregando...</p>
      </div>
    )
  }

  // Urgency colors
  const urgencyColors = {
    normal: 'text-green-400 border-green-700 bg-green-950',
    warning: 'text-yellow-400 border-yellow-700 bg-yellow-950',
    critical: 'text-red-400 border-red-700 bg-red-950',
  }

  const colorClasses = urgencyColors[urgencyLevel]

  return (
    <div className={`p-6 rounded-lg border ${colorClasses}`}>
      <h2 className="text-xl font-bold mb-4">
        Freemium Store - SSR Safe ✅
      </h2>

      <div className="space-y-4">
        {/* Stats Display */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <p className="text-sm text-gray-400">Questões Usadas</p>
            <p className="text-3xl font-bold">{questionsUsed}</p>
          </div>
          <div>
            <p className="text-sm text-gray-400">Restantes</p>
            <p className="text-3xl font-bold">{questionsRemaining}</p>
          </div>
        </div>

        {/* Urgency Indicator */}
        <div className="pt-2 border-t border-gray-700">
          <p className="text-sm text-gray-400">Nível de Urgência</p>
          <p className="text-lg font-semibold capitalize">{urgencyLevel}</p>
        </div>

        {/* Actions */}
        <div className="flex gap-2 pt-2">
          <button
            onClick={incrementQuestionsUsed}
            className="px-4 py-2 bg-blue-600 hover:bg-blue-700 rounded transition-colors"
          >
            Usar Questão
          </button>
          <button
            onClick={resetState}
            className="px-4 py-2 bg-gray-600 hover:bg-gray-700 rounded transition-colors"
          >
            Reset
          </button>
        </div>

        {/* SSR Info */}
        <div className="pt-4 border-t border-gray-700 text-xs text-gray-500">
          <p>✅ Hydrated client-side</p>
          <p>✅ No SSR mismatch</p>
          <p>✅ Persisted in localStorage</p>
        </div>
      </div>
    </div>
  )
}
